import {Component} from '@angular/core';

@Component({
  selector: 'app-error-site',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
})
export class ErrorComponent {}
